<template>
  <div class="about">
    <div>
      <v-img src="../assets/banner.jpg" height="550px"></v-img>
    </div>
    <about-us-component></about-us-component>
  </div>
</template>
<script>
import AboutUsComponent from '../components/AboutUsComponent.vue';

export default {
  components: { AboutUsComponent },
};
</script>
